import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { CategoryType, CategoryVppApplicationConfiguration } from '@rocksoft/settings-sdk';

export interface VppApplicationConfiguration {
  categoryType: CategoryType;
  categoryId: string;
  adamIdStr: string;
  applyFrom?: Date;
  version?: string;
}
export function vppApplicationConfigurationFrom(
  configuration: CategoryVppApplicationConfiguration
): VppApplicationConfiguration {
  return {
    categoryType: configuration.categoryType,
    categoryId: configuration.categoryId,
    adamIdStr: configuration.adamIdStr,
    applyFrom: configuration.applyFrom ? new Date(configuration.applyFrom) : undefined,
    version: configuration.version ?? undefined,
  };
}

export type CategoryVppApplicationsState = EntityState<VppApplicationConfiguration>;

export function selectId(application: VppApplicationConfiguration) {
  return `${application.categoryType}-${application.categoryId}-${application.adamIdStr}-${application.version ?? ''}`;
}

export const adapter: EntityAdapter<VppApplicationConfiguration> = createEntityAdapter<VppApplicationConfiguration>({
  selectId,
});

export const initialState: CategoryVppApplicationsState = adapter.getInitialState();
